<template>
  <div>
    <!--更新案件状态-->
    <el-dialog
      title="更新案件状态"
      :visible.sync="caseStatusVisible"
      width="30%"
      center>
      <div>
        <el-form size="small" label-width="140px">
            <el-select v-model="caseStatusOper.caseStatusSelect" placeholder="请选择" style="width: 100%;">
              <el-option
                v-for="item in caseStatusOper.caseStatusList"
                :key="item.modelCode"
                :label="item.modelName"
                :value="item.modelCode">
              </el-option>
            </el-select>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="caseStatusVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="updateCaseStatus();" size="small">保存</el-button>
      </div>
    </el-dialog>
    <!--更新联系状态-->
    <el-dialog
      title="更新联系状态"
      :visible.sync="contactStatusVisible"
      width="40%"
      center>
      <div>
        <el-form size="small" label-width="140px">
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item label="联系人">
                <el-select v-model="contactStatusOper.contactId" style="width: 100%;" placeholder="请选择联系人">
                  <el-option
                    v-for="item in allContactList"
                    :key="item.contactId"
                    :label="item.name"
                    :value="item.contactId">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item label="联系状态">
                <el-select v-model="contactStatusOper.contactStatusSelect" placeholder="请选择" style="width: 100%;">
                  <el-option
                    v-for="item in contactStatusOper.contactStatusList"
                    :key="item.modelCode"
                    :label="item.modelName"
                    :value="item.modelCode">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="contactStatusVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="updateContactStatus();" size="small">保存</el-button>
      </div>
    </el-dialog>
    <!--更新策略组-->
    <el-dialog
      title="更新策略组"
      :visible.sync="groupVisible"
      width="40%"
      center>
      <el-form label-width="250px">
        <el-form-item label="策略组:">
          <el-select v-model="strategyGroupOper.strategyGroupSelect">
            <el-option
              v-for="item in strategyGroupOper.strategyGroupList"
              :key="item.id"
              :label="item.groupName"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否重置作业起始日:">
          <el-switch
            v-model="strategyGroupOper.isReset">
          </el-switch>&#12288;
          <i class="el-icon-question" title="勾选“重置作业起始日”会以当前日期加上设置的作业天数使用新策略重新作业，如在1号开始作业，设置作业10日，若在5号更新策略时勾选，会以新策略作业至15号。"></i>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="groupVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="updateStrategyGroup();" size="small">保存</el-button>
      </div>
    </el-dialog>
    <!--更新标签-->
    <el-dialog
      title="更新标签"
      :visible.sync="labelVisible"
      width="40%"
      center>
      <div>
        <el-form size="small" label-width="140px">
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item label="联系人">
                <el-select v-model="labelOper.contactId" style="width: 100%;" placeholder="请选择联系人">
                  <el-option
                    v-for="item in allContactList"
                    :key="item.contactId"
                    :label="item.name"
                    :value="item.contactId">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item label="标签">
                <el-select v-model="labelOper.labelSelect" placeholder="请选择" style="width: 100%;">
                  <el-option
                    v-for="item in labelOper.labelList"
                    :key="item.name"
                    :label="item.name"
                    :value="item.name">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="labelVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="updateLabel()" size="small">保存</el-button>
      </div>
    </el-dialog>
    <!--更新承诺还款时间-->
    <el-dialog
      title="更新承诺还款时间"
      :visible.sync="promiseVisible"
      width="40%"
      center>
      <div>
        <el-form size="small" label-width="150px">
          <el-row :gutter="24">
            <el-row :gutter="24">
              <el-col :span="24">
                <el-form-item label="联系人">
                  <el-select v-model="promiseTimeOper.contactId" style="width: 100%;" placeholder="请选择联系人">
                    <el-option
                      v-for="item in allContactList"
                      :key="item.contactId"
                      :label="item.name"
                      :value="item.contactId">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item label="承诺还款时间">
                <el-date-picker type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择承诺还款时间" v-model="promiseTimeOper.promiseTime" style="width: 100%;"/>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="promiseVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="updatePromiseTime()" size="small">保存</el-button>
      </div>
    </el-dialog>
    <!--更新金额-->
    <el-dialog
      title="更新金额"
      :visible.sync="updateAmount"
      width="40%"
      center>
      <div>
        <el-form size="small" label-width="140px">
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item label="已给予减免金额:">
                <el-input v-model="updateAmountOper.deduction" @keyup.native="number"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item label="逾期总额:">
                <el-input v-model="updateAmountOper.overdueAmount" @keyup.native="number"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item label="罚滞总额:">
                <el-input v-model="updateAmountOper.totalPenalty" @keyup.native="number"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item label="委托金额:">
                <el-input v-model="updateAmountOper.delegateAmount" @keyup.native="number"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="updateAmount = false" size="small">取 消</el-button>
        <el-button type="primary" @click="updateTheAmount()" size="small">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
const Base64 = require('js-base64').Base64;

export default {
  props: [
    'updateVisible',
    'contactId',
    'contacts',
    'caseDetail'
  ],
  data() {
    return {
      allContactList: [],
      caseStatusVisible: false,
      contactStatusVisible: false,
      groupVisible: false,
      labelVisible: false,
      promiseVisible: false,
      updateAmount: false,
      currentContactId: null,
      caseStatusOper: {
        caseStatusList: [],
        caseStatusSelect: null
      },
      contactStatusOper: {
        contactId: null,
        contactStatusList: [],
        contactStatusSelect: null
      },
      strategyGroupOper: {
        strategyGroupList: [],
        strategyGroupSelect: null,
        isReset: false
      },
      labelOper: {
        contactId: null,
        labelList: [],
        labelSelect: null
      },
      promiseTimeOper: {
        contactId: null,
        promiseTime: null
      },
      updateAmountOper: {
        deduction: null,
        overdueAmount: null,
        totalPenalty: null,
        delegateAmount: null
      }
    };
  },
  watch: {
    updateVisible(val) {
      // 更新案件状态
      if (val === 'updateCaseStatusVisible') {
        this.getCaseList();
        this.caseStatusVisible = true;
      } else if (val === 'updateContactStatusVisible') {
        this.getContactStatusList();
        this.getContactList();
        this.contactStatusVisible = true;
      } else if (val === 'updateGroupVisible') {
        this.getStrategyGroupList();
        this.groupVisible = true;
      } else if (val === 'updateLabelVisible') {
        this.getLabelList();
        this.getContactList();
        this.labelVisible = true;
      } else if (val === 'promiseVisible') {
        this.getContactList();
        this.promiseVisible = true;
      } else if (val === 'updateAmount') {
        console.warn('更新金额');
        this.updateAmount = true;
      }
    },
    contactId(val) {
      this.currentContactId = val;
      console.warn(val);
    },
    caseDetail(caseDetail) {
      this.updateAmountOper.deduction = caseDetail.caseDetailDTO.deduction;
      this.updateAmountOper.overdueAmount = caseDetail.caseDetailDTO.overdueInfo.overdueAmount;
      this.updateAmountOper.totalPenalty = caseDetail.caseDetailDTO.overdueInfo.totalPenalty;
      this.updateAmountOper.delegateAmount = caseDetail.caseDetailDTO.overdueInfo.delegateAmount;
    },
    // 回传父组件
    caseStatusVisible: 'changeUpdateVisible',
    contactStatusVisible: 'changeUpdateVisible',
    groupVisible: 'changeUpdateVisible',
    labelVisible: 'changeUpdateVisible',
    promiseVisible: 'changeUpdateVisible',
    updateAmount: 'changeUpdateVisible'
  },
  methods: {
    getContactList() {
      const all = [].concat(this.contacts.benrendianhua, this.contacts.lianxiren, this.contacts.repair);
      this.allContactList = [];
      all.forEach((item) => {
        const temp = {};
        temp.contactId = item.contactId;
        temp.name = `${item.contactName}(${item.typeName.replace('电话', '')}${item.phone.substring(0, 3)}****${item.phone.substring(7, 11)})`;
        this.allContactList.push(temp);
      });
    },
    getCaseList() {
      const uri = '/dict/list/caseStatus';
      this.$ajax({
        method: 'GET',
        url: uri
      }).then((res) => {
        console.warn(res);
        this.caseStatusOper.caseStatusList = res.data;
      });
    },
    getContactStatusList() {
      const uri = '/dict/list/benrendianhuaContactStatus';
      this.$ajax({
        method: 'GET',
        url: uri
      }).then((res) => {
        console.warn(res);
        this.contactStatusOper.contactStatusList = res.data;
      });
    },
    getStrategyGroupList() {
      const caseId = Base64.decode(this.$route.params.id).trim();
      const uri = `/caseDetail/strategyList/${caseId}`;
      this.$ajax({
        method: 'GET',
        url: uri
      }).then((res) => {
        console.warn(res);
        this.strategyGroupOper.strategyGroupList = res.data;
      });
    },
    getLabelList() {
      const uri = '/label/commonList';
      this.$ajax({
        method: 'GET',
        url: uri
      }).then((res) => {
        console.warn(res);
        this.labelOper.labelList = res.data;
      });
    },
    updateCaseStatus() {
      const caseId = Base64.decode(this.$route.params.id).trim();
      const uri = '/caseOper/changeStatus';
      this.$ajax({
        prompt: true,
        method: 'POST',
        url: uri,
        contentType: 'application/json',
        data: {
          caseId,
          status: this.caseStatusOper.caseStatusSelect
        }
      }).then(
        this.caseStatusVisible = false
      );
    },
    updateContactStatus() {
      console.warn(this.currentContactId);
      const uri = '/contact/updateContactStatus';
      this.$ajax({
        prompt: true,
        method: 'POST',
        url: uri,
        contentType: 'application/json',
        data: {
          contactId: this.contactStatusOper.contactId,
          status: this.contactStatusOper.contactStatusSelect
        }
      }).then(
        this.contactStatusVisible = false
      );
    },
    updateStrategyGroup() {
      const caseId = Base64.decode(this.$route.params.id).trim();
      const uri = '/caseOper/changeStrategyGroup';
      this.$ajax({
        prompt: true,
        method: 'POST',
        url: uri,
        contentType: 'application/json',
        data: {
          caseId,
          groupId: this.strategyGroupOper.strategyGroupSelect,
          isReset: this.strategyGroupOper.isReset
        }
      }).then(
        this.groupVisible = false
      );
    },
    updateLabel() {
      const uri = '/caseOper/changeLabel';
      this.$ajax({
        prompt: true,
        method: 'POST',
        url: uri,
        contentType: 'application/json',
        data: {
          contactId: this.labelOper.contactId,
          label: this.labelOper.labelSelect
        }
      }).then(
        this.labelVisible = false
      );
    },
    updatePromiseTime() {
      const uri = '/caseOper/changePromisePayTime';
      this.$ajax({
        prompt: true,
        method: 'POST',
        url: uri,
        contentType: 'application/json',
        data: {
          contactId: this.promiseTimeOper.contactId,
          promisePayTime: this.promiseTimeOper.promiseTime
        }
      }).then(
        this.promiseVisible = false
      );
    },
    changeUpdateVisible() {
      this.$emit('updateVisible', null);
    },
    // 正则校验输入参数
    number() {
      this.updateAmountOper.deduction = this.updateAmountOper.deduction.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace(/^\./g, '').replace('.', '$#$')
        .replace(/\./g, '')
        .replace('$#$', '.')
        .replace(/^(\\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');
      this.updateAmountOper.overdueAmount = this.updateAmountOper.overdueAmount.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace(/^\./g, '').replace('.', '$#$')
        .replace(/\./g, '')
        .replace('$#$', '.')
        .replace(/^(\\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');
      this.updateAmountOper.totalPenalty = this.updateAmountOper.totalPenalty.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace(/^\./g, '').replace('.', '$#$')
        .replace(/\./g, '')
        .replace('$#$', '.')
        .replace(/^(\\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');
    },
    // 更新金额提交
    updateTheAmount() {
      const caseId = Base64.decode(this.$route.params.id).trim();
      const req = this.updateAmountOper;
      req.caseId = caseId;
      this.$ajax({
        prompt: true,
        url: '/caseOper/updateTheAmount',
        data: req
      }).then(
        this.updateAmount = false
      );
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/page/main/case/detailUpdate.vue